import { useEffect, useRef, useState } from "react";
import { CaretDown, ArrowSquareOut, Globe } from "@phosphor-icons/react";
import { SISTER_PLATFORMS } from "../lib/sisterPlatforms";

/**
 * Compact "iAAM Network" dropdown for the top bar. Sister platforms only —
 * the rest of the platform nav lives in the sidebar.
 */
export default function NetworkMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const backend = process.env.REACT_APP_BACKEND_URL || "";

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid="network-menu">
      <button
        onClick={() => setOpen((v) => !v)}
        className="label-mono px-3 py-1.5 border border-[#27272A] hover:border-white hover:text-white text-zinc-400 flex items-center gap-1.5"
        data-testid="network-menu-trigger"
      >
        <Globe size={11} weight="bold" /> iAAM NETWORK <CaretDown size={9} weight="bold" className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-[320px] bg-[#0A0A0C] border border-[#27272A] z-50" data-testid="network-menu-dropdown">
          <div className="label-mono px-4 py-2 border-b border-[#27272A]">SISTER PLATFORMS</div>
          {SISTER_PLATFORMS.map((p) => (
            <a
              key={p.key}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-3 px-4 py-3 hover:bg-[#1A1A1D] border-b border-[#27272A] last:border-b-0"
              data-testid={`network-menu-item-${p.key}`}
            >
              <div className="shrink-0 w-9 h-9 bg-[#0A0A0C] border border-[#27272A] overflow-hidden flex items-center justify-center">
                <img src={`${backend}${p.logo}`} alt="" className="w-full h-full object-cover" loading="lazy" onError={(e) => { e.target.style.display = "none"; }} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                  <span className="text-sm text-white">{p.name}</span>
                  <ArrowSquareOut size={9} weight="bold" style={{ color: p.accent }} />
                </div>
                <p className="text-xs text-zinc-400 line-clamp-2 mt-0.5">{p.tagline}</p>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
